export const BACKEND_URL = "global.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "9145617d764aef25219fa0ba3fc44ae2ce7f2eb5952499cd2d58117124fd15c87186abf59eddafe8ccfaaec85b978c010290b8c6b8308cf6a54e3ea7659bf407d5528cb0d690b9e7943d39a52043c86500cf0c558425dec357743b6b53471a13";
export const CERTIFICATE_MODE = "vrf" as const;
export const PARTICIPANTS: string[] = [
    "053dbe878e06151799905246c92f2ac62c28357ca66267dbd6c361f569d3b60c",
    "08e6511beda42a15c340b27ab9b237605c8481be7ed0eafa3135bb528b4f8c5e",
    "0a501a50ee4f429e6e8b9671d251127659d4f80eebf46bb1686be6b2a8a4dec0",
    "16b6d20c941a22ce3bcd8647554c9e8769b5f3ef5e49f8a42eda659829cf5817",
    "1bcd405331f0d05f296691ca9ac4975116d5b4a0a41a9b8503270006bfa395db",
    "2a21be10151d5f4a41627f6e0bfeffc68ff428b9cfcd6f5dce698fc7c9b35b16",
    "3b5dcd28ef02c0cf6f7ef0384cfe07ecdcffce877a0017a003362ee95c918300",
    "3c389b4410fc115bef3ed8c4406e7e6a35ecd74af24dd219c0e501c9fdb79230",
    "41fa885605b46c236b76dca14f1b151cac7da64dfb9faa42d0010e3b43e64588",
    "428df1cdbc6d91e881fd338fe900eb5e0757c9edb1c64b14fae8c37cc3bdf0b5",
    "4bb158ff82f49be6abdb262fa01892d6a4beb7e11992f07c7b6ea2abcc87a445",
    "4ca95a6cf3240b0b5d946ba2f372b06438c32823f731096481ff2b4ade18bee9",
    "4f5e445d9ce296e2bfc1fc39fa53f937b46a1fab9160eb376c464c1dd163300f",
    "4fbfc66d5fb358f26f8888740a37a2b36064414b4d005c89b3f2e9497d92e59b",
    "504a11bdc45350327d648eb12902731257b946d3a295834ec5214a23c17b8d69",
    "51b48e701a86d1fea2f54126f5b2819cc1048b4eaa2a8862f73a92d0909ee021",
    "53c3893409adf684841bec3ee1cad0554882eec5469da5ecc0f0dd33e124477f",
    "55b9b6711c852554b20746b07c9a526b8f35e68585a3eb5ae0ad1c7faa33efed",
    "5a2356cb1f3d9e83513d4162628347d95780d0ec0a95ad8e9219fdb672211cbf",
    "5e918aa8b114175d488f835af7b09bfeafa7d32228c53831345b0becfdbeb274",
    "5fffaf07db3b42854fbd5378c900d03512409db73da7f779f5221896e8cd1a75",
    "6024b3c7108be23b1c991ea67a54ec29db38bc7b955160a2435f57cd8b138c8b",
    "603bf5aae7e768155d670df8c525287ddff9ebca53464e4fd7552b6e8fa5aaa7",
    "6988b151eb3aadc77905d5430923ea54548f5676c4aa385bacc1f5411aa28a16",
    "6ade9c968d4b8da36c769e82d41107f97f24805c935e088c737fd46e6977128e",
    "7e10232f51f41fb029723d06b9d0e9f7b715588fb92296e3bd9e1e577ced458d",
    "800af096bf66e1c4d0cc01c8bf5744d21935402ba118850d814495b5c1662ebc",
    "80a981f1f24d88c556edcedcfcda74bd5093901c3cda7ad599900bfcebf110b2",
    "82c31bad0761ed1bc7f8fda76984a9f812a7de109c784183ffe51c412bbd7af3",
    "82db88e5699e5219c1baefa95a55262f8b037d1cab53096b4c014c8c6dc89847",
    "82dd5795a1c02ce4012f74a65e1ff13e5bc7d18f2d104b84cd42c69dcea460d3",
    "8e61b84910dec940d2414f89c0c25cc854ce20d80ac541fd58c12bdcc76e8646",
    "9049d9cd8cf7e9a2486c415456e8d30b2161c7c089299f3b181b33a1acbf71ad",
    "97cdd2741fad4b4d5a79e64351c6acd52d1f45990c705ba114246a52184615d5",
    "9b1f1afed09110165df3b4c43d67ea4ef3ab53d7bccb92e91a64ec7de1167544",
    "a502a914a63e2227e9480bd59e8a3a46492746e0968c4b0071ce0b47c4de337a",
    "a5fe54d6c34321a4f30816c61bd88c662f84a28df2801b90baf961245d760d0a",
    "a6870ba6bfa3f26ed339e23447194ebd62d9864564975f0c2d7b8121ef2b65fd",
    "b2f130910ac11c625a2336fed392c7f6cf465fa53a6f15efe7e605e0f4f6f6fa",
    "b5b600325ff77421dfd08908400056ffc7fa56833ca2a1c5a9c49811c4ddfa62",
    "b94400e6abd2f5a9a7bf30f78927fa74e94a056820fa4627dd9e330077503927",
    "bb677dd339e4c722acb214b0d0d54131a31ae7dee96dbae55b6ea7a4a951669e",
    "be175894321d8971320940479dd418bc696c982a0d2f1cbb7d51f0e6851cc670",
    "c458ea894e7e2d8833e68e55048dcf4aef0fdbf01d2bac876f680243f73a7029",
    "ca3e9943c53290076fcf5bb55f7119e1bdf356165bda7ee3a68d318b239e525a",
    "cee5637a8a39fd1204413e609d9e194b5f7addc33739d22c567135337bf6a960",
    "ed79390f1a69b8a5fc953120c7d40900b90482cdbe0b63ef94a7a11d5a07f47a",
    "f27796079f5483cf6c11ab179fd0c7429c76d068c8c614bff03f7ad505fc1a83",
    "f2aada9f84b062f8957323267c1398e3601d2f140eacb2a7afb22c7edc5986df",
    "f544766a1827c184005e543e1e3f8d2103a1f06736934a88bdfb62528b405847"
];
export const LOCATIONS: ([[number, number], string] | null)[] = [
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"]
];